import { atom } from 'recoil';
import { ICreateWorkerFormData } from 'forms/worker';
import { ICroppedImage } from 'models/profile-picture/ICroppedImage';

export const individualState = atom<ICreateWorkerFormData | null>({
    key: 'individual:registration',
    default: null
});

export const clientIp = atom<string | null>({
    key: 'individual:clientIp',
    default: null
});

export const individualProfilePicture = atom<ICroppedImage | null>({
    key: 'individual:profilePicture',
    default: null
});

